<template>
  <div class="col-sm-12 col-xs-12 text-right" style="padding: 0">
    <div class="clearfix"></div>
    <ul class="pagination pagination-sm no-margin" lang="de">
      <li class="paginate_button"><button @click="$emit('select', {start: moment().format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD'), filter: 'today'})" :class="['paginate_button page-link', filter === 'today' ? 'active' : '']">{{'today' | translate | capitalize}}</button></li>
      <li class="paginate_button"><button @click="$emit('select', {start: moment().subtract(1, 'day').format('YYYY-MM-DD'), end: moment().subtract(1, 'day').format('YYYY-MM-DD'), filter: 'yesterday'})" :class="['paginate_button page-link', filter === 'yesterday' ? 'active' : '']">{{'yesterday' | translate | capitalize}}</button></li>
      <li class="paginate_button"><button @click="$emit('select', {start: moment().startOf('month').format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD'), filter: 'thisMonth'})" :class="['paginate_button page-link', filter === 'thisMonth' ? 'active' : '']">{{'this_month' | translate}}</button></li>
      <li class="paginate_button"><button @click="$emit('select', {start: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'), end: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'), filter: 'lastMonth'})" :class="['paginate_button page-link', filter === 'lastMonth' ? 'active' : '']">{{'last_month' | translate}}</button></li>
      <li class="paginate_button"><button @click="$emit('select', {start: moment().startOf('year').format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD'), filter: 'thisYear'})" :class="['paginate_button page-link', filter === 'thisYear' ? 'active' : '']">{{'this_year' | translate}}</button></li>
      <li class="paginate_button"><button @click="$emit('select', {start: moment().subtract(1, 'year').format('YYYY-MM-DD'), end: moment().subtract(1, 'year').format('YYYY-MM-DD'), filter: 'lastYearSameTime'})" :class="['paginate_button page-link', filter === 'lastYearSameTime' ? 'active' : '']">{{'last_year_same_time' | translate}}</button></li>
      <li class="paginate_button"><button @click="$emit('select', {start: moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DD'), end: moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD'), filter: 'lastYear'})" :class="['paginate_button page-link', filter === 'lastYear' ? 'active' : '']">{{'last_year' | translate}}</button></li>
      <li class="paginate_button"><button @click="$emit('select', {start: '2017-01-01', end: moment().format('YYYY-MM-DD'), filter: 'total'})" :class="['paginate_button page-link', filter === 'total' ? 'active' : '']">{{'gesamt' | translate}}</button></li>
    </ul>
  </div>
</template>

<script>
  import moment from 'moment'
  export default {
    props: ['filter'],
    name: "timeTabs",
    data() {
      return {}
    },
    methods: {
      moment() {
        return moment()
      }
    },
    mounted () {}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tools/TimeTabs.vue